export function Section({ paddingY, paddingX, ...props }: any) {
  return <section {...props} />;
}
